// Web stand-in for @react-native-community/blur (aliased in
// webpack.config.web.js). Real CSS backdrop-filter blur, not a dummy —
// `blurAmount`/`reducedTransparencyFallbackColor` map directly onto it, so
// this looks correct rather than merely "not crashing".
import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

type BlurViewProps = ViewProps & {
  blurType?: 'dark' | 'light' | 'xlight' | 'extraDark' | 'regular' | 'prominent';
  blurAmount?: number;
  reducedTransparencyFallbackColor?: string;
};

export const BlurView: React.FC<BlurViewProps> = ({
  style,
  blurAmount = 10,
  reducedTransparencyFallbackColor,
  blurType,
  ...rest
}) => (
  <View
    {...rest}
    style={[
      style,
      // @ts-expect-error web-only CSS filter, ignored by native's ViewStyle types
      { backdropFilter: `blur(${blurAmount}px)`, backgroundColor: reducedTransparencyFallbackColor },
      blurType === 'light' || blurType === 'xlight' ? styles.light : null,
    ]}
  />
);

const styles = StyleSheet.create({
  light: { backgroundColor: 'rgba(255,255,255,0.3)' },
});

export default BlurView;
